<template>
  <div>
    <b-form class="b-layout" @submit.prevent="">
      <div v-if="!readOnly">
        <label>{{ $t('operacoes') }} </label>
        <b-form-select
          class="input-pentagro"
          v-model="operationSelected"
          :options="operations"
        ></b-form-select>
      </div>

      <div v-if="operationSelected" class="varieable">
        <b-card class="mt-3">
          <div class="inp">
            <label>{{ $t('consumo-especifico-de-energia-massa-de-entrada') }} </label>
            <input
              v-model="consumoEspecifico.value"
              type="number"
              step="0.02"
            />
          </div>
        </b-card>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      consumoEspecifico: {},
      operations: [{ value: null, text:this.$t('selecione-uma-demanda-de-energia') }],
      operationSelected: null,
      operationAttributeList: [],
      attributesList:this.$t('selecione-uma-demanda-de-energia'),
      firstLoad: false,
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }
      const attrList = ["consumoEspecifico"];
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => attrList.includes(operation.key));

      this.consumoEspecifico = this.operationAttributeList.find(
        (p) => attrList[0] == p.caption
      );

      if (this.consumoEspecifico)
        this.consumoEspecifico.value = ParseToNumber(
          this.consumoEspecifico.value
        );

        this.updateNode();
    },

    "consumoEspecifico.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        this.firstLoad = true;
      }

      this.node.data.forEach((p) => {
        if (p.caption == "consumoEspecifico") {
          p.value = ParseToNumber(p.value);
          this.consumoEspecifico = p;
        }
      });
    },

    updateNode() {
      this.node.attrs = [this.consumoEspecifico.clone()];
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/DemandaEnergia/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    setTimeout(this.loadNode(), 200);
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.varieables {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
}

input {
  margin-left: 20px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>